export const Messages = {
  upgrade: 'Upgrade',
  upgradeTo: (version: string) => `Upgrade to ${version}`,
};
